module.exports = __webpack_public_path__ + "static/chris_evagora-5f5afee1633ff24bfc7c2910fb42d6d8.jpg";